export default __webpack_public_path__ + "static/media/madhu-pandit-signature.764dd54b.png";